import * as go from 'gojs';
import {
  CONVERSIONS,
  convertToCurrentMetric,
  getMetricUnit,
} from 'util/conversions';
import { getDiagram } from '../../../goDiagram';

const $ = go.GraphObject.make;

/**
 * Template for displaying unit info data
 */
export const linkOutputFlowPanel = () =>
  $(
    go.TextBlock,
    {
      stroke: '#fff',
      alignment: go.Spot.Bottom,
      margin: new go.Margin(0, 4, 0, 4),
    },
    new go.Binding('text', '', (node) => {
      if (!node.massFlows) {
        return null;
      }
      return `${convertToCurrentMetric({
        value: node.outputFlow,
        metricType: node.metricType,
        conversionType: CONVERSIONS.CAPACITY,
        decimals: 0,
      })} ${getMetricUnit(node.metricType, CONVERSIONS.CAPACITY)}`;
    }),
    new go.Binding('font', '', (link) => {
      const diagram = getDiagram();
      if (!diagram || !link?.from) {
        return 'normal normal 500 14px Sandvik Sans Text';
      }
      const currentNode = diagram.findNodeForKey(link.from);
      const currentFontSize = currentNode?.data?.canvasBodyFontSize;
      return `normal normal 500 ${
        currentFontSize?.size ?? 14
      }px Sandvik Sans Text`;
    }),
  );
